import { VersionFragment } from '@sketch/gql-types'
import type { ShareForDocumentItem } from 'modules/shares/components/DocumentItem'
import type { TrashedShare } from 'modules/shares/components/TrashItemsLayout'

type PreviewFileDocument = Pick<
  NonNullable<VersionFragment['document']>,
  'previewFile'
>

export type PreviewFile = Pick<
  NonNullable<PreviewFileDocument['previewFile']>,
  'thumbnails' | 'url'
>

export const getShareThumbnail = (
  share: ShareForDocumentItem | TrashedShare
) => {
  if (!share.version?.document?.previewFile?.thumbnails?.length) {
    return
  }

  const { thumbnails } = share.version.document.previewFile

  const largeThumbnail = thumbnails.find(x => x?.type === 'L')?.url
  const previewFile = thumbnails[0]?.url

  return largeThumbnail || previewFile || undefined
}
